import { fetchData } from '@/utils/fetch'
import { usePlugin } from '@/hooks/usePlugin'
import { createSharedComposable } from '@vueuse/core'

const coupon = ref(null)

/**
 * 处理 满减券 相关逻辑
 */
export const useCoupon = createSharedComposable(() => {
  const { $toast } = usePlugin()
  const isInvaliding = ref(false)

  const initCoupon = async () => {
    const { code, data } = await fetchData('/appb/b2b/coupon/getUsable')
    if (code === 200) {
      coupon.value = data
    }
  }

  const invalidateCoupon = async (couponCode) => {
    if (isInvaliding.value) return
    isInvaliding.value = true
    const { code, msg } = await fetchData('/appb/b2b/coupon/invalid', {
      method: 'POST',
      body: JSON.stringify({ couponCode })
    })
    if (code === 200) {
      initCoupon()
    } else {
      $toast(msg, { type: 'error' })
    }
    isInvaliding.value = false
  }

  const reset = () => {
    coupon.value = null
    initCoupon()
  }

  onBeforeMount(() => {
    initCoupon()
  })

  return { initCoupon, coupon, invalidateCoupon, reset }
})
